module.exports = __webpack_public_path__ + "static/media/inf_01pog02p.de5bed99.mp3";